<div class="contact-information-container">

    <app-dynamic-form [readOnly]="readonly" [formGroup]="contactForm" [formConfig]="contactFormConfig" (onValueChange)="handleValueChange($event)"></app-dynamic-form>

    <div class="divider"></div>

    <div class="contact-person-container">
        <div class="contact-person-header">
            <span class="contact-person-title">Contact Persons</span>
            <button type="button" class="tertiary_button" *ngIf="action !== 'view'" (click)="addContactPerson()">
                <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
                Add Contact Person</button>
        </div>

        <div class="contact-person-list">
            <div class="contact-person-item" *ngFor="let contactPersonForm of contactPersons.controls; let i = index">
                <div class="contact-person-item-header">
                    <span class="contact-person-item-name">Contact Person {{i + 1}}</span>
                    <button type="button" class="secondary_button delete_button" (click)="removeContactPerson(i)" *ngIf="i > 0 && action !== 'view'">
                        <app-svg-icon [path]="'assets/icons/delete_icon.svg'"></app-svg-icon>
                        Delete
                    </button>
                </div>

                <div class="divider"></div>

                <div class="contact-person-form-container">
                    <app-dynamic-form [formGroup]="contactPersonForm" [formConfig]="personFormConfig"></app-dynamic-form>
                </div>
            
            </div>
        </div>
    </div>
</div>